<script>
    import { onMount } from 'svelte';
    import { fetchUserByResetHash } from '../services/users/users';
    import ResetPassword from '/public/components/users/ResetPassword.svelte';
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';

    let loading = true;

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;

    let user = null;

    onMount(() => {
        fetchUserByResetHash(hash).then(res => {
            if (res.success) {
                user = res.data.user;
                loading = false;
            }
        });
    });


</script>

<div class='vh-100'>
    <div class='container-fluid'>
        <div class="row justify-content-center mb-5">
            <div class="col-sm-12 col-md-10 col-lg-8 col-xl-4 col-xxl-4">
                
                <ThexaHero/>

                {#if loading === true}
                
                    <div class='mt-5 mb-5 text-center'>
                        <h4>
                            <span class='ajax-ball-loader'></span>
                        </h4>
                    </div>                                

                {:else}
                    
                    <ResetPassword user={user} hash={hash}/>
                    
                {/if}

            </div>
        </div>
    </div>
</div>
